import * as React from 'react';

const Uk24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1F2F1",
    d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#BD0034", d: "M4.323 17.883 10.54 13.9H9.29l-5.616 3.597c.188.167.408.299.65.386Z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#1A237B",
    d: "M3 10.34h4.42L3.056 7.526A2 2 0 0 0 3 8zm1.506-4.278 6.174 3.968V6H5q-.256 0-.494.062"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#BD0034", d: "M11.24 6v5.05H3v2.14h8.24V18h1.67v-4.81H21v-2.14h-8.09V6z" }), /* @__PURE__ */ React.createElement("path", { fill: "#BD0034", d: "m20.593 6.79-5.543 3.55h-1.24l6.277-4.019q.294.19.506.47Z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#1A237B",
    d: "M20.963 7.614 16.73 10.34H21V8a2 2 0 0 0-.037-.386M13.47 6v4.03l6.148-3.933A2 2 0 0 0 19 6z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#BD0034", d: "m3.233 7.06 5.097 3.28h1.24L3.64 6.532q-.248.23-.408.529Z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#1A237B",
    d: "M3.117 16.675A2 2 0 0 1 3 16v-2.1h4.42zM4.987 18h5.693v-3.79l-5.902 3.778q.103.011.21.012Z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#BD0034", d: "M20.766 16.94 16.02 13.9h-1.25l5.581 3.574a2 2 0 0 0 .415-.534" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#1A237B",
    d: "m19.36 17.968-5.89-3.758V18h5.543q.178-.001.346-.032ZM21 13.9h-4.27l4.186 2.676A2 2 0 0 0 21 16z"
  }
));
Uk24.Size = 24;
Uk24.Title = "Uk";

export { Uk24 as default };
